<template>
  <v-flex xs12 sm6 md4 lg3 :class="customClass">
    <v-card :color="integrata ? 'red lighten-5' : ''">
      <v-card-title class="pb-1">
        <div class="title align-center secondary--text">
          {{ $moment(item.data).format('MMMM YYYY') }} {{integrata ? '- integrazione' : ''}} 
          <v-tooltip right>
              <template slot="activator">
                  <v-icon
                    v-if="1 == item.chiuso"
                    color="red" 
                    >lock</v-icon>
              </template>
              <span>Mensilità chiusa</span>
          </v-tooltip>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          v-if="false !== sendType && !readonly"
          absolute
          right
          flat
          icon
          class="white--text"
          color="green darken-2"
          @click.stop="sendHandler"
        >
            <v-tooltip right>
                <template slot="activator">
                    <v-icon color="green darken-2">send</v-icon>
                </template>
                <span v-text="sendTooltip"></span>
            </v-tooltip>
        </v-btn>
      </v-card-title>
      <v-card-title class="pt-1">
        <div class="subheading align-center tree--text">{{ item.nome_utente }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-list dense :class="integrata ? 'red lighten-5' : ''">
        <template v-for="(spesa, index) in item.spese">
          <v-hover open-delay="200">
            <v-list-tile class="spesa-item my-2" slot-scope="{ hover }">
              <v-list-tile-content :class="hover && !readonly ? 'v-card--reveal__bg' : ''">
                <v-list-tile-title
                  class="subheading font-weight-bold secondary--text"
                  :style="[{color: verificaSpesaData(spesa.data) ? '#E53935!important' : '#304156 !important' }]"
                >{{ $moment(spesa.data).format('dddd, DD/MM/YYYY') }}</v-list-tile-title>
                <v-list-tile-sub-title v-text="spesa.causale"></v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <v-icon
                    v-for="(itm, j) in spesa.items"
                    :key="j"
                    small
                    class="px-1"
                    :color="iconColor(itm)"
                  >{{itm.icon}}</v-icon>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action
                class="subheading font-weight-bold secondary--text align-self-baseline"
                :class="hover && !readonly ? 'v-card--reveal__bg' : ''"
              >{{ importoTotaleForDate(spesa.items) }} €</v-list-tile-action>
              <v-expand-transition>
                <div v-if="hover" class="d-layout transition-fast-in-fast-out v-card--reveal">
                  <v-btn
                    color="green darken-2"
                    outline
                    @click.stop="$emit('on-click-verifica', item.login, item.spesa_id, spesa.data)"
                  >
                    <v-icon color="green darken-2">fas fa-eye</v-icon>
                  </v-btn>
                </div>
              </v-expand-transition>
            </v-list-tile>
          </v-hover>
        </template>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content class="subheading font-weight-bold secondary--text">Spese aziendale:</v-list-tile-content>
          <v-list-tile-action
            class="subheading font-weight-bold secondary--text"
          >{{ importoTotaleAzindale(item.spese) }} €</v-list-tile-action>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content class="subheading font-weight-bold secondary--text">Totale:</v-list-tile-content>
          <v-list-tile-action
            class="subheading font-weight-bold secondary--text"
          >{{ importoTotaleForUser(item.spese) }} €</v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "acc-verifica-note-card",
  components: {},
  props: {
    item: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    hover: true,
    sendType: false,
    sendTooltip: ''
  }),
  updated() {
      this.checkSendHandler();
  },
  created() {
      this.checkSendHandler();
  },
  computed: {
    note () {
        return this.item.spese.map(nt => nt.items).flat()
    },
    integrata () {
//        return !this.$moment(this.item.data).isSame(this.$moment(), 'month')
        return false
    },
    iconColor() {
      return item => {
        if (Boolean(+item.is_anticipata_azienda)) return "blue darken-3";
        return (item.stato == 1 || item.stato == 4)
          ? "green darken-2"
          : (item.stato == 2 || item.stato == 5)
          ? "red lighten-2"
          : item.stato == 3
          ? "yellow darken-2"
          : "grey lighten-2";
      };
    },
    quantitaTotale() {
        return this.note.length
    },
    isLavorata() {
        return this.note.filter(n => n.stato == 0).length === 0
    },
    inAttesa() {
        return this.note.filter(n => n.stato == 3).length !== 0
    },
    isSAMM () {
      return this.item.inviata_gm != 2  
    },
    isGM () {
      return this.item.inviata_gm == 2  
    },
    verificaSpesaData() {
      return data => {
        return (
          this.$moment(data, "YYYY-MM-DD").month() !==
          this.$moment(this.item.data, "YYYY-MM-DD").month()
        );
      };
    },
    isAggiuntive() {
      return (
        this.item.spese.filter(spesa => {
          return this.verificaSpesaData(spesa.data);
        }).length !== this.item.spese.length
      );
    }
  },
  methods: {
    importoTotaleForDate(items) {
      return items
        .filter(itm => (+itm.stato === 1 || +itm.stato === 4) && !Boolean(+itm.is_anticipata_azienda))
        .map(itm => parseFloat(itm.importo))
        .reduce((prev, next) => prev + next, 0)
        .toFixed(2);
    },
    importoTotaleForUser(spese) {
      let total = 0;

      spese.forEach(sp => {
        total += sp.items
          .filter(
            itm => (+itm.stato === 1  || +itm.stato === 4) && !Boolean(+itm.is_anticipata_azienda)
          )
          .map(itm => parseFloat(itm.importo))
          .reduce((prev, next) => prev + next, 0);
      });

      return total.toFixed(2);
    },
    importoTotaleAzindale(spese) {
      let total = 0;

      spese.forEach(sp => {
        total += sp.items
          .filter(
            itm => (+itm.stato === 1  || +itm.stato === 4) && Boolean(+itm.is_anticipata_azienda)
          )
          .map(itm => parseFloat(itm.importo))
          .reduce((prev, next) => prev + next, 0);
      });

      return total.toFixed(2);
    },
    checkSendHandler() {
        if (this.isSAMM && this.isLavorata && !this.inAttesa ) {
            this.sendType = 'GM'
            this.sendTooltip = 'Invia a GM per confermare'
        }else if (this.isGM && this.isLavorata && this.inAttesa ) {
            this.sendType = 'SAMM'
            this.sendTooltip = 'Invia a SAMM per modificare'
        } else if (this.isGM && this.isLavorata && !this.inAttesa ) {
            this.sendType = 'PROTOCOL'
            this.sendTooltip = 'Invia per protocollare'
        }
        
        if ((this.isSAMM && this.isLavorata && this.inAttesa) || (this.isSAMM && !this.isLavorata) || (this.isGM && !this.isLavorata) ) {
            this.sendType = false
            this.sendTooltip = ''
        }
    },
    sendHandler() {
        this.$emit('on-click-invia', this.item.spesa_id, this.sendType)
    }
  }
};
</script>

<style lang="scss">
.v-menu.v-menu--inline.spesa-item__menu {
  width: 100%;
  .spesa-item {
    width: 100%;
  }
}
.spesa-item__menu-container {
  .spesa-item__menu-content {
    padding: 0;
    .v-list__tile {
      padding: 0;
      height: 45px;
      .v-btn {
        height: 100%;
        min-width: 56px;
      }
    }
  }
}
.v-card--reveal {
  display: flex;
  align-items: center;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  justify-content: center;
  position: absolute;
}
.v-card--reveal__bg {
  filter: blur(3px);
  -webkit-filter: blur(3px);
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/VerificaNoteCard.vue